import React, { useContext, useEffect, useMemo } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { HybridTourContent } from '@/nikeone/components/TournamentContent';
import BoxOptionsContext, { ARTICLE } from '@/nikeone/context/BoxOptionsContext';
import BoxStoreContext from './BoxStoreContext';
import { normalizeTournamentId } from '@/nikeone/domain/sportevent';
import useBoxStore from '@/nikeone/hook/useBoxStore';
import { cmsBetsLoad } from '@/nikeone/handlers';
import BetbookContext from 'nike-ui/src/common/BetbookContext';
import { nike1SportEvent$ } from '@/nikeone/subs';

function ArticleBetsCompatIn({ selectionId, tournamentId: tid, betId }) {
    let tournamentId = normalizeTournamentId(tid);
    // zobrazujeme vsetky boxy spojene s jednym modulom z cmska -> preto vytvarame boxStore pre kazdy z modulov -> aby sme vedeli ktore boxy patria ku ktoremu modulu
    const boxStoreName = useContext(BoxStoreContext) || 'empty-name';
    const boxStore = useMemo(() => `cms:${boxStoreName}:${tournamentId || '-'}:${betId || '-'}`, [
        boxStoreName,
        tournamentId,
        betId
    ]);
    useBoxStore(boxStore);
    useEffect(() => {
        if (!tournamentId && !betId) {
            return;
        }
        let editorTips;
        if (betId && selectionId && selectionId.length) {
            editorTips = { [betId]: selectionId };
        }
        dispatch(cmsBetsLoad(tournamentId, editorTips, boxStore, betId));
    }, [boxStore, tournamentId, selectionId, betId]);
    const derefSub = useReframe();

    if (!tournamentId && !betId) {
        return null;
    }

    const boxes = derefSub(['nikeone/boxes', boxStore]);
    if (!boxes || !boxes.size) {
        return null;
    }
    return (
        <div className="markdown-bets">
            <BoxOptionsContext.Provider value={ARTICLE}>
                {boxes.keySeq().map(boxId => (
                    <ArticleAccordion boxStore={boxStore} boxId={boxId} key={boxId} />
                ))}
            </BoxOptionsContext.Provider>
        </div>
    );
}

function ArticleAccordion({ boxStore, boxId }) {
    const { derefSub, subscribe } = useReframe();
    const boxEmpty = derefSub(['nikeone/box/isEmpty', boxStore, boxId]);
    if (boxEmpty) {
        return null;
    }
    const firstSportEventId = derefSub(['nikeone/box/firstSportEventId', boxStore, boxId]);
    const sportEvent = subscribe(nike1SportEvent$(boxStore, firstSportEventId));

    if (!sportEvent) {
        return null;
    }
    return (
        <div data-atid="accordion" className="accordion active">
            <h1 className="accordion-head flex items-center">
                <span>{sportEvent.tournamentName}</span>
            </h1>
            <HybridTourContent boxStore={boxStore} boxId={boxId} />
        </div>
    );
}

function ArticleBetsCompat(props) {
    const { isBetbook } = useContext(BetbookContext);
    if (isBetbook) {
        return null;
    }
    return <ArticleBetsCompatIn {...props} />;
}

export default ArticleBetsCompat;
